import { BuisnessPromotion } from 'src/app/models/common';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { Component, NgZone, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddAdminPostComponent } from 'src/app/shared/components/add-admin-post/add-admin-post.component';
import { NavigationService } from '../../../providers/navigation.service';

@Component({
  selector: 'sm-admin-post',
  templateUrl: './admin-post.component.html',
  styleUrls: ['./admin-post.component.scss'],
})
export class AdminPostComponent implements OnInit, OnDestroy {
  private _apiSubscription: Subscription = new Subscription();
  public adminPostList: BuisnessPromotion[] = [];
  public modelSubscription: Subscription = new Subscription();
  public page: number = 1;
  public isLoading: boolean = false;
  constructor(
    private _modelRef: MatDialog,
    private _apiService: ApiService,
    private _ngZone: NgZone,
    private _navService: NavigationService,
  ) {
    this._navService.hideSidebarAndNav = false;
  }
  public totalData: number = 0;

  ngOnInit(): void {
    this.isLoading = true;
    this._apiService.getAdminPostInfoList('1');
    this._apiService.getAdminPostListCount('1');
    this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
      this.isLoading = true;
      this._apiService.getAdminPostInfoList(this.page.toString());
    });
    this._apiSubscription = this._apiService.apiResult.subscribe((response) => {
      console.log(response);
      if (response.responseType === SM_CONSTANTS.GET_ADMIN_POST_LIST_RESULT) {
        if (response.result) {
          this.adminPostList = response.result;
        }
      }
      if (
        response.responseType === SM_CONSTANTS.GET_ADMIN_POST_LIST_COUNT_RESULT
      ) {
        if (response.result) {
          this._ngZone.run(() => {
            this.totalData = response.result[0]?.totalRecords;
          });
        }
        this._apiService.getAdminPostInfoList('1');
      }
      if (
        response.responseType === SM_CONSTANTS.UPDATE_ADMIN_POST_INFO_RESULT
      ) {
        console.log('hello');

        this._apiService.getAdminPostInfoList(this.page.toString());
      }
      this.isLoading = false;
    });
  }

  openModel(event: any) {
    this._modelRef.open(AddAdminPostComponent, {
      minWidth: '400px',
      data: {
        title: 'Edit business post',
        type: SM_CONSTANTS.BUISNESS_PROMOTION,
        ref: this._modelRef,
        data: event,
      },
    });
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
    this.modelSubscription.unsubscribe();
  }

  onPageChange(ev: any) {
    this.isLoading = true;
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    this._apiService.getAdminPostInfoList(this.page.toString());
  }

  onCreateNewPost() {
    this._modelRef.open(AddAdminPostComponent, {
      minWidth: '400px',
      data: {
        title: 'Add admin post',
        type: SM_CONSTANTS.ADMIN_POST,
        ref: this._modelRef,
      },
    });
  }
}
